import { api, TCustomAxiosPaginationResponse } from '..';
import { TApiAssessment, TAssessment, TCreateAssessment } from '@/types/Assessment.types';
import { getFormattedAssessmentTemplate } from '@/utils/documentTemplatesFormatter';
import { TScreenerApiResponse, TScreenerListItemApiResponse } from '@/types/Screener.types';
import { label4BEMapper } from '@/utils/mappers/label';
import { apiPaths } from '@/services/api/paths';
import { SUPER_ADMIN_PAGE_SIZE } from '@/constants/numberVars';

export const getAllAssessments = async (page: number): Promise<TCustomAxiosPaginationResponse<TApiAssessment[]>> => {
  const { data } = await api.get(apiPaths.assessments.root, {
    params: {
      limit: SUPER_ADMIN_PAGE_SIZE,
      page,
    },
  });

  return data;
};

export const createAssessmentPost = async ({ slug, title, type }: TCreateAssessment): Promise<TApiAssessment> => {
  const template = getFormattedAssessmentTemplate({ slug, title, type });

  const { data } = await api.post(apiPaths.assessments.create, {
    data: template,
    slug,
    title,
    type,
  });

  const assessment: TApiAssessment = data.data;

  return assessment;
};

export const deleteAssessmentById = async ({ id }: { id: string }): Promise<any> => {
  const { data } = await api.delete(apiPaths.assessments.byId(id));

  return data;
};

export const updateAssessmentById = async ({ id, data }: { id: string; data: TAssessment }): Promise<any> => {
  const {
    type,
    slug,
    props: { title },
  } = data;

  const { data: responseData } = await api.put(apiPaths.assessments.byId(id), {
    title,
    slug,
    type,
    data,
  });

  return responseData;
};

export const getAssessmentById = async ({ id }: { id: string }): Promise<TApiAssessment> => {
  const { data } = await api.get(apiPaths.assessments.byId(id));

  const assessments = data.data;

  return assessments;
};

export const getScreenersListByUserId = async (
  page: number,
  queryParams?: {
    id: string;
  },
  sortingColumn?: string,
  sortingDirection?: string,
): Promise<TCustomAxiosPaginationResponse<TScreenerListItemApiResponse[]>> => {
  const params: { [key: string]: string | number | boolean } = {
    limit: 10,
    page,
  };

  params['sortBy'] = label4BEMapper(sortingColumn ?? 'createdAt');
  params['sortOrder'] = sortingDirection ?? 'desc';

  const { data } = await api.get<TCustomAxiosPaginationResponse<TScreenerListItemApiResponse[]>>(
    apiPaths.assessments.userScreeners(String(queryParams?.id)),
    { params },
  );

  return data;
};

export const getScreenerById = async (id: string): Promise<TScreenerApiResponse> => {
  const { data } = await api.get(apiPaths.assessments.screenerById(id));

  const screener = data.data;

  return screener;
};
